<template>
    <div>
        <swb-query-sort-area ref="query_model" :config="queryConfig" :queryHandler="queryHandler"></swb-query-sort-area>
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="自建客户" name="first">
                <swb-viurtual-retailer-list-select ref="swb_viurtual_retailer_list_select" :multiSelect="multiSelect" :checkedIds="checkedIds" :checkedItem="checkedItem" :seachQueryModel="queryModel" @handle-change="handleChange"></swb-viurtual-retailer-list-select>
            </el-tab-pane>
            <el-tab-pane label="平台客户" name="second">
                <swb-platform-retailer-list-select ref="swb_platform_retailer_list_select" :multiSelect="multiSelect" :checkedIds="checkedIds" :checkedItem="checkedItem" :seachQueryModel="queryModel" @handle-change="handleChange"></swb-platform-retailer-list-select>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>
<script>
    import { Utils, $ } from '../../app.base'
    import { Vue, MsgBox, DomSizeWatcher, showPageRangeSelDlg } from '../../app.vues'
    import SwbQuerySortArea from '../query/QuerySortArea';
    Vue.regist(SwbQuerySortArea);
    //
    import SwbPlatformRetailerForSelect from '../platformRetailer/RetailerForSelect';
    Vue.regist(SwbPlatformRetailerForSelect);
    import SwbVirtualRetailerForSelect from '../virtualMerchant/RetailerForSelect';
    Vue.regist(SwbVirtualRetailerForSelect);

    let searchConfigData = {
        "queryFields": [{
            "type": "Text",
            "label": "客户名称",
            "code": "name",
            "valueType": "String",
            "basic": true
        }, {
            "type": "Text",
            "label": "统一社会信用代码",
            "code": "socialCreditCode",
            "valueType": "String",
            "basic": true
        }, {
            "type": "Text",
            "label": "组织机构代码",
            "code": "orgCode",
            "valueType": "String",
            "basic": true
        }, {
            "type": "Text",
            "label": "系统编号",
            "code": "no",
            "valueType": "String",
            "basic": true
        }, {
            "type": "Text",
            "label": "联系人",
            "code": "contactName",
            "valueType": "String",
            "basic": true
        }, {
            "type": "Text",
            "label": "联系电话",
            "code": "contactTel",
            "valueType": "String",
            "basic": true
        }],
        "sortFields": []
    };
    export default {
        name: 'swb-rent-retailer-list-select',
        avlActions: '',
        avlScopes: 'servicer',
        desc: '零售商选择',
        props: {
            multiSelect: {
                type: Boolean,
                default: false
            },
            checkedIds: {// 多选的时候传入
                type: Array,
                default: function () {
                    return [];
                }
            },
            checkedItem: {//单选初始选择项
                type: Object,
                default: null
            },
        },
        data: function () {
            return {
                queryConfig: searchConfigData || {},
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {}
                },
                activeName: "first",
                checkedId: null,
                checkedIds: [],
                checkedList: [],
                checkedItem: {},
            }
        },
        created: function () {
            //
        },
        methods: {
            handleClick(tab, event) {
            },
            handleChange(item){
                if(!this.multiSelect) {
                    this.checkedItem = item;
                }
            },
            //
            queryHandler(queryModel) {
                //缓存查询条件
                this.operation = this.activeName;
                this.queryModel = Utils.merge({}, queryModel);
            },
            getDlgResult: function () {
                let self = this;
                let result = {};
                //
                if(!this.multiSelect) {
                    let checkedItem = this.checkedItem || null;
                    if(Utils.isNoB(checkedItem.id)) {
                        result.type = 'warn';
                        result.message = '请选择零售商客户！';
                    } else {
                        result.type = 'info';
                        result.data = checkedItem;
                    }
                } else {
                    let viurtualResult = self.$refs.swb_viurtual_retailer_list_select.getDlgResult() || {};
                    let viurtualRetailtList = viurtualResult.data || [];
                    let platformResult = self.$refs.swb_platform_retailer_list_select.getDlgResult() || {};
                    let platformRetailtList = platformResult.data || [];
                    if(viurtualRetailtList.length > 0 || platformRetailtList.length > 0) {
                        let retailerList = viurtualRetailtList;
                        let ids = retailerList.pluck("id");
                        platformRetailtList.forEach(function (item) {
                            if(ids.indexOf(item.id) < 0) {
                                retailerList.push(item);
                            }
                        });
                        result.type = 'info';
                        result.data = retailerList;
                    } else {
                        result.type = 'warn';
                        result.message = '请选择零售商客户！';
                    }
                }
                return result;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/retailer/RetailerRentForSelect.vue